export type SupportCategory =
  "access" | "pd_day" | "attendance" | "content" | "technical" | "other";

export type SupportStatus = "open" | "waiting_for_user" | "resolved";

export interface SupportTicket {
  id: string;
  category: SupportCategory;
  subject: string;
  description: string;
  status: SupportStatus;
  requester_id: string;
  requester: string;
  assigned_id: string;
  requester_role: "teacher" | "facilitator";
  created_at: string;
  updated_at: string;
}

export interface SupportMessage {
  id: string;
  author_role: "requester" | "staff";
  author: string;
  body: string;
  created_at: string;
}

export interface SupportTicketDetail {
  ticket: SupportTicket;
  messages: SupportMessage[];
}

export function supportDate(value: string, language: string): string {
  return new Intl.DateTimeFormat(language === "ur" ? "ur-PK" : "en-PK", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Karachi",
  }).format(new Date(value));
}
